import SearchForm from "@shared/components/SearchForm";
import DirectMessages from "./DirectMessages";
import theme from "@shared/utils/themeColors";

interface MessageSidebarProps {
  selectedConversation: string;
  setSelectedConversation: React.Dispatch<React.SetStateAction<string>>;
  msgSidebarOpen: boolean;
  setMsgSidebarOpen: (open: boolean) => void;
}

const MessagesSidebar: React.FC<MessageSidebarProps> = ({
  selectedConversation,
  setSelectedConversation,
  msgSidebarOpen,
  setMsgSidebarOpen,
}) => {
  return (
    <div
      id="messages-sidebar"
      className={`absolute z-20 top-0 bottom-0 w-full md:w-auto md:static md:top-auto md:bottom-auto -mr-px md:translate-x-0 transition-transform duration-200 ease-in-out ${
        msgSidebarOpen ? "translate-x-0" : "-translate-x-full"
      }`}
    >
      <div className={`sticky top-16 bg-white dark:bg-[#151D2C] overflow-x-hidden overflow-y-auto no-scrollbar shrink-0 border-r ${theme.border.primary} md:w-[18rem] xl:w-[20rem] h-[calc(100dvh-64px)]`}>
        {/* #Marketing group */}
        <div>
          {/* Group body */}
          <div className="px-5 py-4">
            {/* Search form */}
            <SearchForm placeholder="Search..." onChange={() => {}} />
            {/* Direct messages */}
            <DirectMessages
              setMsgSidebarOpen={setMsgSidebarOpen}
              selectedConversation={selectedConversation}
              setSelectedConversation={setSelectedConversation}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessagesSidebar;
